import { useEffect } from 'react';
import AppLoader from '../../common/components/AppLoader';
import { endImpersonation } from '../../services/impersonationSession';

// Rendered where an impersonation tab has nothing left to show; leaves for the dealer app after the render.
export const EndImpersonation = ({ reason }) => {
    useEffect(() => {
        endImpersonation(reason);
    }, [reason]);

    return <AppLoader />;
};
